import cloneDeep from 'lodash/cloneDeep.js';
import keyBy from 'lodash/keyBy.js';
import { VERSION } from '../constants/Storyboard.js';
import migrations from './index.js';

/**
 * @param {number|string} fromVersion
 * @param {number|string} toVersion
 * @returns {('up'|'down'|'same')}
 */
function getMigrationDirection(fromVersion, toVersion) {
  fromVersion = parseInt(fromVersion || 0);
  toVersion = parseInt(toVersion || 0);
  const comparison = fromVersion - toVersion;

  if (comparison < 0) {
    return 'up';
  } else if (comparison > 0) {
    return 'down';
  } else {
    return 'same';
  }
}

/**
 * @param {Object} schema
 * @param {number|string} toVersion
 * @param {Object} migrations - map of migrations, key = fromVersion
 * @returns {Object}
 */
function _migrate(schema, toVersion, migrations = {}) {
  const fromVersion = parseInt(schema.version || schema.schemaVersion || 0);
  const direction = getMigrationDirection(fromVersion, toVersion);

  if (direction === 'same') {
    return schema;
  }

  const currentMigration =
    migrations[direction === 'up' ? fromVersion : fromVersion - 1];

  const newSchema = cloneDeep(currentMigration[direction](schema));

  return _migrate(newSchema, toVersion, migrations);
}

/**
 * @param {Object} schema
 * @param {number|string} toVersion
 * @param {array} migrations
 * @returns {Object}
 */
export default function migrate(schema, toVersion = VERSION) {
  const migrationsByFromVersion = keyBy(migrations, (migration) =>
    parseInt(migration.from || 0)
  );

  return _migrate(schema, toVersion, migrationsByFromVersion);
}
